import { FC } from 'react';
import { Box, Flex, Skeleton } from '@chakra-ui/react';
import { ContentContainerType } from 'types/enums';
import { ContentContainer } from 'app/components/Core';

const lyricsSheetWidth = 768;
const paperWrapperSx = {
  flexDirection: 'column',
  maxWidth: lyricsSheetWidth,
  width: '100%',
  minHeight: '100vh',
  padding: 10,
  boxShadow: '0px 8px 24px rgba(50, 51, 61, 0.15)',
  borderRadius: 8,
};

export const LyricsFormLoader: FC = () => {
  return (
    <ContentContainer
      type={ContentContainerType.LIST}
      isViewContent
      centerContent
    >
      <Box sx={paperWrapperSx} data-testid="song-lyrics-loader">
        <Flex direction="column" height="full">
          <Skeleton height="38px" mb="30px" />
          {Array.from(new Array(5)).map((item, index) => (
            <Skeleton
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              height="18px"
              width={`${Math.floor((4 - index) * 10) + 40}%`}
              mb="6px"
            />
          ))}
        </Flex>
      </Box>
    </ContentContainer>
  );
};
